import React, { useEffect, useRef, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import styles from "../style.module.scss";
import CustomButton from "shared/components/customButton";
import { toastMessage } from "shared/components/toast";
import Loader from "shared/components/loader/animation";

import {
  createGenreService,
  updateGenresService,
} from "shared/services/productManagerService";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface AddGenreProps {
  open: boolean;
  handleClose: any;
  selectedCategory: any;
  getAllGenres: any;
}

export default function AddGenre({
  open,
  handleClose,
  selectedCategory,
  getAllGenres,
}: AddGenreProps) {
  const [category, setCategory] = useState<any>("");
  const [description, setDiscription] = useState<any>("");
  const [metaName, setMetaName] = useState<any>("");
  const [metaDescription, setMetaDescription] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const [icon, setIcon] = useState({
    raw: null,
    preview: selectedCategory?.icon || "",
  });
  const [banner, setBanner] = useState({
    raw: null,
    preview: selectedCategory?.banner || "",
  });
  const iconRef = useRef<HTMLInputElement | null>(null);
  const bannerRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (selectedCategory) {
      console.log("Selected Category:", selectedCategory);
      setCategory(selectedCategory?.name);
      setDiscription(selectedCategory?.description);
      // Handle both camelCase and snake_case from API
      setMetaName(
        selectedCategory?.meta_title || selectedCategory?.metaTitle || "",
      );
      setMetaDescription(
        selectedCategory?.meta_description ||
          selectedCategory?.metaDescription ||
          "",
      );
      setIcon({
        raw: null,
        preview: selectedCategory?.icon || "",
      });
      setBanner({
        raw: null,
        preview: selectedCategory?.banner || "",
      });
    } else {
      // Reset states when adding new category
      setCategory("");
      setDiscription("");
      setMetaName("");
      setMetaDescription("");
      setIcon({ raw: null, preview: "" });
      setBanner({ raw: null, preview: "" });
    }
    // eslint-disable-next-line
  }, [selectedCategory]);

  const handleSubmit = () => {
    let service = selectedCategory ? updateGenresService : createGenreService;

    const formData = new FormData();
    formData.append("name", category);
    formData.append("description", description);
    formData.append("meta_title", metaName);
    formData.append("meta_description", metaDescription);

    if (icon.raw) {
      formData.append("icon", icon.raw);
    }
    if (banner.raw) {
      formData.append("banner", banner.raw);
    }

    if (selectedCategory) {
      formData.append("id", selectedCategory?.id);
    }

    setLoader(true);
    if (category.length) {
      service(formData)
        .then(({ data }) => {
          setLoader(false);
          console.log(data, "form data sumitted");
          toastMessage("success", data?.message);
          onClose();
          getAllGenres();
        })
        .catch((err) => {
          console.log("Err", err?.response?.data?.message);
          toastMessage("error", err?.response?.data?.message);
          setLoader(false);
        });
    } else {
      toastMessage("error", "Please type in something to proceed.");
      setLoader(false);
    }
  };

  const onClose = () => {
    handleClose();
    setCategory("");
    setDiscription("");
    setMetaName("");
    setMetaDescription("");
    setIcon({ raw: null, preview: "" });
    setBanner({ raw: null, preview: "" });
  };

  const handleImageChange = (e: any, banner: boolean) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setIcon({
          preview: e.target.result as string,
          raw: file,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleBannerImg = (e: any, banner: boolean) => {
    const file = e.target.files && e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e: any) => {
        setBanner({
          preview: e.target.result as string,
          raw: file,
        });
      };

      reader.readAsDataURL(file);
    }
  };

  const handleImageDelete = () => {
    setIcon({ preview: "", raw: null });
    if (iconRef.current) {
      iconRef.current.value = "";
    }
  };
  const handleBannerImageDelete = () => {
    setBanner({ preview: "", raw: null });
    if (bannerRef.current) {
      bannerRef.current.value = "";
    }
  };

  const handleButtonClick = () => {
    if (iconRef.current) {
      iconRef.current.click();
    }
  };
  const handleBannerButtonClick = () => {
    if (bannerRef.current) {
      bannerRef.current.click();
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
      >
        <DialogContent>
          <Icons.CrossIcon
            className={styles.crossIcon}
            onClick={() => handleClose()}
          />

          <div className={styles.categoryTitle}>
            {selectedCategory ? "Update" : "Add"} Genre
          </div>
          <label className={styles.label}>
            {selectedCategory ? "Update" : "Add"} Title
          </label>
          <input
            className={styles.inputCategory}
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          />
          <label className={styles.areaLabel}>
            {selectedCategory ? "Update" : "Add"} Genre Description
          </label>

          <textarea
            style={{ width: "100%" }}
            className={styles.textarea}
            onChange={(e) => setDiscription(e.target.value)}
            value={description}
          />

          <label className={styles.label} style={{ marginTop: "15px" }}>
            {selectedCategory ? "Update" : "Add"} Meta Title
          </label>
          <input
            className={styles.inputCategory}
            value={metaName}
            onChange={(e) => setMetaName(e.target.value)}
          />

          <label className={styles.areaLabel}>
            {selectedCategory ? "Update" : "Add"} Meta Description
          </label>
          <textarea
            style={{ width: "100%" }}
            className={styles.textarea}
            onChange={(e) => setMetaDescription(e.target.value)}
            value={metaDescription}
          />

          <div style={{ marginTop: "15px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleImageChange(e, true)}
              ref={iconRef}
              style={{ display: "none" }}
            />
            <div className={styles.iconImgContainer}>
              {icon?.preview && (
                <Icons.DeleteIcon
                  className={styles.deleteIcon}
                  onClick={() => handleImageDelete()}
                />
              )}
              {icon.preview ? (
                <img
                  src={icon.preview && icon.preview}
                  alt={"Icon"}
                  className={styles.iconImg}
                  onClick={() => handleButtonClick()}
                />
              ) : (
                <div
                  className={`${styles.uploadContainer} ${styles.iconContainer}`}
                  onClick={() => handleButtonClick()}
                >
                  <Icons.UploadFileIcon />
                  <label>Please Upload Icon</label>
                </div>
              )}
            </div>
          </div>
          <div style={{ marginTop: "15px" }}>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => handleBannerImg(e, true)}
              ref={bannerRef}
              style={{ display: "none" }}
            />
            <div className={styles.bannerImgContainer}>
              {banner?.preview && (
                <Icons.DeleteIcon
                  className={styles.deleteIcon}
                  onClick={() => handleBannerImageDelete()}
                />
              )}
              {banner.preview ? (
                <img
                  src={banner.preview && banner.preview}
                  alt={"Genre Banner"}
                  className={styles.bannerImg}
                  onClick={() => handleBannerButtonClick()}
                />
              ) : (
                <div
                  className={`${styles.uploadContainer} ${styles.bannerContainer}`}
                  onClick={() => handleBannerButtonClick()}
                >
                  <Icons.UploadFileIcon />
                  <label>Please Upload Genre Banner</label>
                </div>
              )}
            </div>
          </div>

          <div className={styles.btnContainer}>
            <CustomButton
              text={selectedCategory ? "Update" : "Add"}
              buttonStyle={styles.btnCustom}
              handleClick={() => handleSubmit()}
            />
            <CustomButton
              text="Cancel"
              buttonStyle={styles.btnInsideOut}
              handleClick={() => handleClose()}
            />
          </div>
        </DialogContent>

        {loader && <Loader />}
      </Dialog>
    </div>
  );
}
